// Svg
import navigation from "../Assets/navigation";

export const navigationRoute = [
  {
    path: "dashboard",
    label: "Dashboard",
    svg: navigation?.dashboard,
  },
  {
    path: "users",
    label: "Users",
    svg: navigation?.users,
  },
  {
    path: "application",
    label: "Applications",
    svg: navigation?.application,
  },
  {
    path: "user-type",
    label: "Manage User Level",
    svg: navigation?.manageType,
  },
  {
    path: "ai-usage",
    label: "AI Usage",
    svg: navigation?.sensAI,
  },
  {
    path: "ai-settings",
    label: "AI Settings",
    svg: navigation?.sensAISetting,
  },
  {
    path: "ab-testing",
    label: "AB Testing",
    svg: navigation?.abtesting,
  },
  {
    path: "analytics",
    label: "Analytics",
    svg: navigation?.analytics,
  },
  {
    path: "content",
    label: "Content",
    svg: navigation?.content,
  },
  {
    path: "notification-template",
    label: "Notification Template",
    svg: navigation?.notification,
  },
  {
    path: "faq",
    label: "FAQ",
    svg: navigation?.faq,
  },
  {
    path: "support",
    label: "Support",
    svg: navigation?.support,
  },
  {
    path: "subscription",
    label: "Subscription",
    svg: navigation?.subscription,
  },
  {
    path: "transaction",
    label: "Transaction History",
    svg: navigation?.transaction,
  },
  {
    path: "manage-plan",
    label: "Manage Plan",
    svg: navigation?.manageType,
  },
];

export const banner = {
  content: {
    heading: <>Choose Your Perfect Plan</>,
    description: `An ecosystem that is future-facing and creator-led.`,
  },
  className: "mb-3 mb-md-4",
};
